import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { layerAccessGrantsKeys } from './layerAccessGrantsKeys'
import { buildErrorMessage } from 'utils'
import { useArticlePassword } from 'hooks/useArticlePassword'

interface Props {
  articleKey: string
  layerId: string
}

export const useRevokeAllLayerAccessGrants = ({ articleKey, layerId }: Props) => {
  const queryClient = useQueryClient()
  const password = useArticlePassword(articleKey)

  return useMutation(
    layerAccessGrantsKeys.revokeAll(layerId, password),
    async () => {
      const response = await sendToApi<{}>(`/articles/${articleKey}/layers/${layerId}/accesses`, {
        method: 'DELETE',
      })
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return null
    },
    {
      onMutate: () => {
        const currentAccessGrants = queryClient.getQueryData(layerAccessGrantsKeys.list(layerId, { password }))
        // Optimistic update
        queryClient.setQueryData(layerAccessGrantsKeys.list(layerId, { password }), undefined)
        return currentAccessGrants
      },
      onError: (_error, _variables, oldAttributes) => {
        queryClient.setQueryData(layerAccessGrantsKeys.list(layerId, { password }), oldAttributes)
      },
      onSuccess: () => {
        queryClient.invalidateQueries(layerAccessGrantsKeys.list(layerId, { password }))
      },
    },
  )
}
